import { ArrowLeft, ExternalLink, Image, MapPin, Phone, ScanSearch, Type } from 'lucide-react';
import Brand from './Brand';

function Evidence({ result }) {
  return (
    <div className="evidence-row">
      {result.textScore > 0.2 && <span><Type size={14} /> Name {Math.round(result.textScore * 100)}%</span>}
      {result.visualScore > 0.2 && <span><Image size={14} /> Image {Math.round(result.visualScore * 100)}%</span>}
    </div>
  );
}

export default function ResultsView({ image, text, results, onReset, onOpen }) {
  const top = results[0];
  return (
    <div className="results-page page-frame">
      <header className="simple-header"><Brand /><button className="text-button" onClick={onReset}><ArrowLeft size={17} /> New scan</button></header>
      <main className="results-main">
        <section className="result-context">
          <div className="captured-thumb">{image ? <img src={image} alt="Captured storefront" /> : <ScanSearch />}</div>
          <div><span className="eyebrow">Recognition result</span><h1>{top ? 'We found a likely match' : 'No confident match yet'}</h1><p dir="auto">{text ? `Detected: ${text.replace(/\s+/g, ' ').slice(0, 160)}` : 'The sign text was unclear, so visual matching was used.'}</p></div>
        </section>

        {top ? (
          <>
            <article className="top-result-card">
              <div className="top-result-image">{top.coverImage ? <img src={top.coverImage} alt={top.name} /> : <ScanSearch />}</div>
              <div className="top-result-body">
                <div className="confidence-ring" style={{ '--score': `${Math.round(top.confidence * 100) * 3.6}deg` }}><span>{Math.round(top.confidence * 100)}%</span></div>
                <span className="result-label">Best match</span>
                <h2>{top.name}</h2>
                {top.nameAr && <h3 dir="rtl">{top.nameAr}</h3>}
                <div className="restaurant-meta">
                  {top.location && <span><MapPin size={16} /> {top.location}</span>}
                  {top.phone && <a href={`tel:${top.phone}`}><Phone size={16} /> {top.phone}</a>}
                </div>
                <Evidence result={top} />
                <button className="primary-button" onClick={() => onOpen(top)} disabled={!top.menuUrl}>Open menu <ExternalLink size={18} /></button>
              </div>
            </article>

            {results.length > 1 && <section className="alternatives"><div className="section-heading"><div><span className="eyebrow">Other possibilities</span><h2>Similar matches</h2></div></div><div className="alternative-grid">{results.slice(1).map((result) => <article className="alternative-card" key={result.id}><div className="alternative-image">{result.coverImage ? <img src={result.coverImage} alt={result.name} /> : <ScanSearch />}</div><div><strong>{result.name}</strong>{result.nameAr && <span dir="rtl">{result.nameAr}</span>}<Evidence result={result} /></div><button onClick={() => onOpen(result)} disabled={!result.menuUrl}><ExternalLink size={17} /></button></article>)}</div></section>}
          </>
        ) : (
          <section className="empty-result">
            <ScanSearch />
            <h2>No indexed match was found</h2>
            <p>The photo may be clear, but the restaurant folder may not be indexed yet. Confirm that the Firebase document ID exactly matches the reference-image folder name, then refresh the admin dashboard.</p>
            <button className="primary-button" onClick={onReset}>Try again</button>
          </section>
        )}
      </main>
    </div>
  );
}
